import { createAction, props } from '@ngrx/store';
import { FilterBaseControl } from '@gelato-api-ui/core/apps-and-services/types/getty-filters-response';

export const load = createAction('[GettyFilters] Load');

export const loadSuccess = createAction('[GettyFilters] Load Success', props<{ payload: FilterBaseControl[] }>());

export const loadError = createAction('[GettyFilters] Load Error');
